/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import Avatar from 'react-avatar';
import { connect } from 'react-redux';
import Layout from '../../../../../components/Layout';
import Link from '../../../../../components/Link';

const messages = defineMessages({
  congratulations: {
    id: 'auth.complete.congratulations',
    defaultMessage: 'Congratulations!',
    description: 'Congratulations Message',
  },
  completedSignup: {
    id: 'auth.complete.completedSignup',
    defaultMessage: 'You have just completed the salon mySKP sign up process and are one step away from gaining access.',
    description: 'Completed Signup Message',
  },
  reviewingAccount: {
    id: 'auth.complete.reviewingAccount',
    defaultMessage: 'A Schwarzkopf Professional will be reviewing your account and will get back to you with approval between 1-2 business days from time of resgitration.',
    description: 'Reviewing Account Message',
  },
  returnLink: {
    id: 'auth.complete.returnLink',
    defaultMessage: 'RETURN TO MYSKP',
    description: 'Return Link',
  },
});

class Complete extends Component {
  static contextTypes = {
    routeParams: PropTypes.object.isRequired,
  };

  static propTypes = {
    session: PropTypes.object.isRequired,
  };

  render() {
    const { siteId } = this.context.routeParams;
    const { session } = this.props;
    const userData = session.USER_DATA;
    const avatarSrc =
      userData.avatar != null && 'media' in userData.avatar
        ? `/${siteId}/asset/${userData.avatar.media
            ._id}?width=125&height=125&type=fill`
        : '/images/salon-avatar.svg';
    return (
      <Layout layoutType="clear">
        <div className="complete">
          <div className="complete__content">
            {/* <img src="/images/salon-avatar.svg" className="complete__avatar" /> */}
            <Avatar
              size={115}
              round
              className="avatar__image"
              src={avatarSrc}
            />
            <div className="complete__title">
              <span>{userData.firstname},</span>{' '}
              <FormattedMessage {...messages.congratulations} />
            </div>
            <div className="complete__text">
              <p>
                <FormattedMessage {...messages.completedSignup} />
              </p>
              <p>
                <FormattedMessage {...messages.reviewingAccount} />
              </p>
            </div>
            <Link to={`/${siteId}`} className="complete__btn">
              <FormattedMessage {...messages.returnLink} />
            </Link>
            <img src="/tile-wide.png" alt="" className="complete__logo" />
          </div>
        </div>
      </Layout>
    );
  }
}

export default connect(state => ({ session: state.session }))(Complete);



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/complete/Complete.js